import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';
import type {
    FetchRequestsColumnSettingsModel,
    FetchRequestsColumnSettingsSuccess,
    FetchRequestsColumnSettingsFailure,
} from '@helpcenter/requests-column-settings';
import {
    FETCH_REQUESTS_COLUMN_SETTINGS_MODEL,
    fetchRequestsColumnSettingsSuccess,
    fetchRequestsColumnSettingsFailure,
} from '@helpcenter/requests-column-settings';
import fetchModel from 'epics/model/fetcher';
import type { ErrorResponse } from 'epics/model/types';

export const requestsColumnSettingsEpic: Epic<
    FetchRequestsColumnSettingsModel,
    FetchRequestsColumnSettingsSuccess | FetchRequestsColumnSettingsFailure
> = (action$) => {
    return action$.ofType(FETCH_REQUESTS_COLUMN_SETTINGS_MODEL).mergeMap((action) =>
        fetchModel(action.payload)
            .filter((response) => !!response.requestsColumnSettings)
            .map((response) => {
                return fetchRequestsColumnSettingsSuccess(response.requestsColumnSettings || []);
            })
            .catch((error: ErrorResponse) => {
                return Observable.of(fetchRequestsColumnSettingsFailure(error));
            })
    );
};
